import './index.css'
import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect, Link} from 'react-router-dom'
import {formatDistanceToNow} from 'date-fns'
import Loader from 'react-loader-spinner'

import {IoIosClose} from 'react-icons/io'
import {FaSearch} from 'react-icons/fa'
import Header from '../Header'
import ThemeContext from '../ThemeContext'
import LeftPortion from '../LeftPortion'


const apiStatus = {
  initial: 'INITIAL',
  loading: 'LOADING',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

const VideoCard = ({videoDetails, theme}) => {
  const {id, title, thumbnailUrl, channel, viewCount, publishedAt} =
    videoDetails
  const {name, profileImageUrl} = channel
  const publishedDate = formatDistanceToNow(new Date(publishedAt))

  return (
    <li className="video-card-list-item">
      <Link to={`/videos/${id}`} className="video-card-link">
        <img
          src={thumbnailUrl}
          className="video-card-thumbnail"
          alt="video thumbnail"
        />
        <div className="video-card-details">
          <img
            src={profileImageUrl}
            alt="channel logo"
            className="video-card-channel-logo"
          />
          <div className="video-card-text-container">
            <p className={`video-card-title ${theme}`}>{title}</p>
            <p className="video-card-channel-name">{name}</p>
            <div className="video-card-stats">
              <p>{viewCount} views</p>
              <p className="dot-separator">•</p>
              <p>{publishedDate} ago</p>
            </div>
          </div>
        </div>
      </Link>
    </li>
  )
}

class Home extends Component {
  state = {
    videoList: [],
    searchInput: '',
    fetchStatus: apiStatus.initial,
    isBannerVisible: true,
  }

  componentDidMount() {
    this.fetchVideos()
  }

  fetchVideos = async () => {
    this.setState({fetchStatus: apiStatus.loading})
    const {searchInput} = this.state
    const apiUrl = `https://apis.ccbp.in/videos/all?search=${searchInput}`
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${jwtToken}`},
      method: 'GET',
    }

    try {
      const response = await fetch(apiUrl, options)
      if (response.ok) {
        const data = await response.json()
        const formattedData = data.videos.map(each => ({
          id: each.id,
          title: each.title,
          thumbnailUrl: each.thumbnail_url,
          channel: {
            name: each.channel.name,
            profileImageUrl: each.channel.profile_image_url,
          },
          viewCount: each.view_count,
          publishedAt: each.published_at,
        }))
        this.setState({
          videoList: formattedData,
          fetchStatus: apiStatus.success,
        })
      } else {
        this.setState({fetchStatus: apiStatus.failure})
      }
    } catch (error) {
      this.setState({fetchStatus: apiStatus.failure})
    }
  }

  handleSearchInputChange = event => {
    this.setState({searchInput: event.target.value})
  }

  handleSearch = () => {
    this.fetchVideos()
  }

  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.fetchVideos()
    }
  }

  handleRetry = () => {
    this.setState({searchInput: ''}, this.fetchVideos)
  }

  closeBanner = () => {
    this.setState({isBannerVisible: false})
  }

  renderLoadingView = () => (
    <div className="view-container" data-testid="loader">
      <Loader type="ThreeDots" color="#4f46e5" height="50" width="50" />
    </div>
  )

  renderFailureView = theme => (
    <div className="view-container">
      <img
        className="failure-image"
        src={
          theme === 'light-theme'
            ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'
            : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
        }
        alt="failure view"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>
        We are having some trouble completing your request. Please try again.
      </p>
      <button className="retry-button" type="button" onClick={this.handleRetry}>
        Retry
      </button>
    </div>
  )

  renderNoResultsView = () => (
    <div className="view-container">
      <img
        alt="no videos"
        className="no-results-image"
        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-search-results-img.png"
      />
      <h1>No Search results found</h1>
      <p>Try different keywords or remove the search filter.</p>
      <button className="retry-button" type="button" onClick={this.handleRetry}>
        Retry
      </button>
    </div>
  )

  renderSuccessView = theme => {
    const {videoList} = this.state
    return videoList.length === 0 ? (
      this.renderNoResultsView()
    ) : (
      <ul className="videos-grid-container">
        {videoList.map(each => (
          <VideoCard key={each.id} videoDetails={each} theme={theme} />
        ))}
      </ul>
    )
  }

  renderApiStatusView = theme => {
    const {fetchStatus} = this.state
    switch (fetchStatus) {
      case apiStatus.loading:
        return this.renderLoadingView()
      case apiStatus.success:
        return this.renderSuccessView(theme)
      case apiStatus.failure:
        return this.renderFailureView(theme)
      default:
        return null
    }
  }

  render() {
    if (Cookies.get('jwt_token') === undefined) {
      return <Redirect to="/login" />
    }

    const {searchInput, isBannerVisible} = this.state

    return (
      <ThemeContext.Consumer>
        {value => {
          const {activeThemeIsLight} = value
          const theme = activeThemeIsLight ? 'light-theme' : 'dark-theme'

          return (
            <>
              <Header />
              <div className="home-container" data-testid="home">
                <LeftPortion />
                <div className={`main-content ${theme}`}>
                  {isBannerVisible && (
                    <div className="banner-container" data-testid="banner">
                      <div className="banner-content">
                        <img
                          alt="nxt watch logo"
                          className="banner-logo"
                          src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
                        />
                        <p>Buy Nxt Watch Premium prepaid plans with UPI</p>
                        <button type="button" className="get-it-now-button">
                          GET IT NOW
                        </button>
                      </div>
                      <button
                        type="button"
                        className="close-banner-button"
                        onClick={this.closeBanner}
                        data-testid="close"
                      >
                        <IoIosClose size={24} />
                      </button>
                    </div>
                  )}

                  <div className="content-body">
                    <div className="search-bar">
                      <input
                        type="search"
                        placeholder="Search"
                        className={`search-input ${theme}`}
                        value={searchInput}
                        onChange={this.handleSearchInputChange}
                        onKeyDown={this.handleKeyDown}
                      />
                      <button
                        type="button"
                        className={`search-button ${theme}`}
                        onClick={this.handleSearch}
                        data-testid="searchButton"
                      >
                        <FaSearch />
                      </button>
                    </div>
                    {this.renderApiStatusView(theme)}
                  </div>
                </div>
              </div>
            </>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default Home
